import React from 'react';
import { AppButton, Box, Inscription } from '@common-fe/common-fe';

import { useSpendLimitsModalStore } from '../stores/useSpendLimitsModal.store';

import { SpendLimitItem } from './SpendLimitItem';

interface Props {
  onCancel: () => void;
  onApply: () => void;
}

const testId = 'SpendLimitsForm';

export const SpendLimitsForm: React.FC<Props> = ({ onCancel, onApply }) => {
  const categories = useSpendLimitsModalStore((state) => state.categories);

  return (
    <Box data-testid={testId}>
      <Box margin={{ bottom: 'spacing8' }}>
        <Inscription
          size="2xl"
          weight="bold"
          color="textBody"
          textAlign="center"
          data-testid={`${testId}_title`}
        >
          Spend Limits
        </Inscription>
      </Box>

      <Box
        pad="spacing24"
        margin={{ bottom: 'spacing24' }}
        round="moduleRound"
        background={{ color: 'module' }}
        gap="spacing12"
      >
        <Box
          pad="spacing24"
          border={{ color: 'border1' }}
          round="container1Round"
          background={{ color: 'canvas' }}
          gap="spacing16"
        >
          {categories.map((category) => (
            <SpendLimitItem key={category.id} categoryType={category.category} />
          ))}
        </Box>
      </Box>

      <Box direction="row" gap="spacing12" width="100%" data-testid={`${testId}_actions`} justify="end">
        <Box width="150px">
          <AppButton testId={`${testId}_cancel`} buttonType="secondary" onClick={onCancel} width="100%">
            Cancel
          </AppButton>
        </Box>
        <Box width="150px">
          <AppButton testId={`${testId}_apply`} onClick={onApply} width="100%">
            Apply
          </AppButton>
        </Box>
      </Box>
    </Box>
  );
};
